(function(){
'use strict';
var N=window.ndala||{routes:{}};
function $(s,c){return (c||document).querySelector(s)}
function $$(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))}
function money(cents){
  var f=N.moneyFormat||'{{amount}}';var m=f.match(/\{\{\s*(\w+)\s*\}\}/);if(!m)return String(cents);
  function fmt(n,d,ts,ds){var s=(n/100).toFixed(d).split('.');s[0]=s[0].replace(/\B(?=(\d{3})+(?!\d))/g,ts);return s[1]?s[0]+ds+s[1]:s[0]}
  var v;switch(m[1]){
    case 'amount_no_decimals':v=fmt(cents,0,',','.');break;
    case 'amount_with_comma_separator':v=fmt(cents,2,'.',',');break;
    case 'amount_no_decimals_with_comma_separator':v=fmt(cents,0,'.',',');break;
    case 'amount_with_apostrophe_separator':v=fmt(cents,2,"'",'.');break;
    case 'amount_no_decimals_with_space_separator':v=fmt(cents,0,' ','.');break;
    default:v=fmt(cents,2,',','.')}
  return f.replace(m[0],v).replace(/<[^>]*>/g,'');
}
N.money=money;
var toastTimer;
function toast(msg,withCart){
  var t=$('#toast');if(!t)return;t.innerHTML='';
  var s=document.createElement('span');s.textContent=msg;t.appendChild(s);
  if(withCart){var a=document.createElement('a');a.href=N.routes.cart_url;a.className='btn btn--accent btn--sm';a.textContent='View cart';a.setAttribute('data-cart-open','');t.appendChild(a)}
  t.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(function(){t.hidden=true},4000);
}
/* cart drawer */
var lastFocus;
function openDrawer(){if(!$('[data-drawer]'))return false;lastFocus=document.activeElement;document.body.classList.add('drawer-open');var p=$('.drawer__panel');if(p)p.focus();var t=$('#toast');if(t)t.hidden=true;return true}
function closeDrawer(){document.body.classList.remove('drawer-open');if(lastFocus&&lastFocus.focus)lastFocus.focus()}
function sectionIds(){var ids=['cart-drawer'];$$('[data-cart-section]').forEach(function(el){ids.push(el.getAttribute('data-cart-section'))});return ids}
function renderSections(sections){
  if(!sections)return;
  Object.keys(sections).forEach(function(id){
    var host=document.getElementById('shopify-section-'+id);if(!host||sections[id]==null)return;
    var d=document.createElement('div');d.innerHTML=sections[id];
    var inner=d.querySelector('#shopify-section-'+id);host.innerHTML=inner?inner.innerHTML:d.innerHTML;
  });
  syncCounts();paintWish();
  if(document.body.classList.contains('drawer-open')){var p=$('.drawer__panel');if(p)p.focus()}
}
function syncCounts(){
  var c=$('[data-src-count]'),t=$('[data-src-total]');
  if(c)$$('[data-cart-count]').forEach(function(el){el.textContent=c.textContent});
  if(t)$$('[data-cart-total]').forEach(function(el){el.textContent=t.textContent});
}
function post(url,body){return fetch(url,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)}).then(function(r){return r.json()})}
function addToCart(items,btn){
  var body={items:items,sections:sectionIds().join(','),sections_url:location.pathname};
  if(btn){btn.setAttribute('aria-busy','true')}
  return post(N.routes.cart_add_url+'.js',body).then(function(res){
    if(res.status&&res.status!==200){toast(res.description||res.message||'Could not add to cart');return}
    if(N.cartType==='page'){location.href=N.routes.cart_url;return}
    renderSections(res.sections);
    if(N.cartType==='drawer')openDrawer();
    else toast(((res.items&&res.items[0])?res.items[0].product_title:'Item')+' added to cart',true);
  }).catch(function(){toast('Connection problem — please try again')}).then(function(){if(btn)btn.removeAttribute('aria-busy')});
}
function changeLine(line,qty){
  document.body.classList.add('cart-busy');
  post(N.routes.cart_change_url+'.js',{line:line,quantity:qty,sections:sectionIds().join(','),sections_url:location.pathname}).then(function(res){
    if(res.status&&res.status!==200&&res.description)toast(res.description);
    renderSections(res.sections);
  }).catch(function(){toast('Connection problem — please try again')}).then(function(){document.body.classList.remove('cart-busy')});
}
/* wishlist */
var WK='ndala:wishlist';
function getWish(){try{return JSON.parse(localStorage.getItem(WK))||[]}catch(e){return []}}
function setWish(a){try{localStorage.setItem(WK,JSON.stringify(a))}catch(e){}paintWish()}
function paintWish(){
  var a=getWish();
  $$('[data-wish]').forEach(function(b){var on=a.indexOf(b.getAttribute('data-wish'))>-1;b.setAttribute('aria-pressed',on?'true':'false');var l=on?'Remove from wishlist':'Save to wishlist';b.setAttribute('aria-label',l);b.setAttribute('title',l)});
  $$('[data-wish-count]').forEach(function(el){el.textContent=a.length;el.hidden=!a.length});
}
function toggleWish(h){
  var a=getWish(),i=a.indexOf(h);
  if(i>-1){a.splice(i,1);toast('Removed from wishlist')}else{a.unshift(h);toast('Saved to wishlist')}
  setWish(a);
  var grid=$('[data-wishlist-grid]');
  if(grid&&i>-1){var card=grid.querySelector('[data-card="'+h+'"]');if(card)card.parentNode.removeChild(card);if(!a.length)loadWishlist()}
}
function loadWishlist(){
  var grid=$('[data-wishlist-grid]');if(!grid)return;
  var a=getWish(),empty=$('[data-wishlist-empty]');
  if(!a.length){grid.innerHTML='';if(empty)empty.hidden=false;return}
  if(empty)empty.hidden=true;
  var root=(N.routes.root||'/').replace(/\/$/,'');
  Promise.all(a.map(function(h){return fetch(root+'/products/'+encodeURIComponent(h)+'?view=card').then(function(r){return r.ok?r.text():''}).catch(function(){return ''})})).then(function(html){
    grid.innerHTML=html.join('');paintWish();
    if(!grid.children.length&&empty)empty.hidden=false;
  });
}
/* product */
function showMedia(p,id){
  $$('[data-media-id]',p).forEach(function(m){m.classList.toggle('is-active',m.getAttribute('data-media-id')==id)});
  $$('[data-thumb]',p).forEach(function(t){t.setAttribute('aria-current',t.getAttribute('data-thumb')==id?'true':'false')});
}
function initProduct(root){
  $$('[data-product]',root).forEach(function(p){
    var js=$('[data-variants]',p),opts=$('[data-options]',p);if(!js||!opts)return;
    var variants=JSON.parse(js.textContent);
    function selected(){return $$('fieldset',opts).map(function(fs){var c=fs.querySelector('input:checked');return c?c.value:null})}
    function find(s){for(var i=0;i<variants.length;i++){var v=variants[i],ok=true;for(var j=0;j<s.length;j++){if(v.options[j]!==s[j]){ok=false;break}}if(ok)return v}return null}
    function update(first){
      var s=selected(),v=find(s);
      $$('fieldset',opts).forEach(function(fs,i){
        var l=$('[data-opt-label]',fs);if(l)l.textContent=s[i]||'';
        $$('input',fs).forEach(function(inp){var t=s.slice();t[i]=inp.value;var m=find(t);inp.parentNode.classList.toggle('is-unavailable',!m||!m.available)});
      });
      var idIn=$('[data-variant-id]',p),add=$('[data-add]',p),buy=$('[data-buy-now]',p),so=$('[data-soldout]',p),pr=$('[data-price]',p),badge=$('[data-sale-badge]',p);
      if(!v){if(add){add.disabled=true;add.textContent='Unavailable'}if(buy)buy.disabled=true;return}
      if(idIn)idIn.value=v.id;
      if(add){add.disabled=!v.available;add.textContent=v.available?(add.getAttribute('data-label')||'Add to cart'):'Sold out'}
      if(buy)buy.disabled=!v.available;
      if(so)so.hidden=v.available;
      $$('[data-restock-variant]',p).forEach(function(i){i.value=v.name||v.title});
      if(pr){var h='<span class="price__now">'+money(v.price)+'</span>';if(v.compare_at_price>v.price){h+='<s class="price__was">'+money(v.compare_at_price)+'</s><span class="price__save">You save '+money(v.compare_at_price-v.price)+'</span>'}pr.innerHTML=h}
      if(badge){if(v.compare_at_price>v.price){badge.hidden=false;badge.textContent='Save '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'}else badge.hidden=true}
      if(v.featured_media&&!first)showMedia(p,v.featured_media.id);
      if(!first&&window.history&&history.replaceState){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState(null,'',u.toString())}
    }
    opts.addEventListener('change',function(){update(false)});
    update(true);
  });
}
function initTabs(root){
  $$('[data-tabs]',root).forEach(function(w){
    var tabs=$$('[role=tab]',w);
    tabs.forEach(function(t){t.addEventListener('click',function(){
      tabs.forEach(function(x){var on=x===t;x.setAttribute('aria-selected',on?'true':'false');x.tabIndex=on?0:-1;var p=document.getElementById(x.getAttribute('aria-controls'));if(p)p.hidden=!on});
      var more=$('[data-tab-more]',w);if(more&&t.getAttribute('data-href'))more.href=t.getAttribute('data-href');
    })});
  });
}
function initRecos(root){
  $$('[data-recos]',root).forEach(function(el){
    var u=el.getAttribute('data-url');if(!u||el.getAttribute('data-loaded'))return;el.setAttribute('data-loaded','1');
    fetch(u).then(function(r){return r.text()}).then(function(t){var d=document.createElement('div');d.innerHTML=t;var n=d.querySelector('[data-recos]');if(n&&n.innerHTML.trim()){el.innerHTML=n.innerHTML;paintWish()}});
  });
}
function initSelects(root){$$('select[data-default]',root).forEach(function(s){var v=s.getAttribute('data-default');if(v)s.value=v})}
function init(root){initProduct(root);initTabs(root);initRecos(root);initSelects(root)}
/* events */
document.addEventListener('click',function(e){
  var t=e.target;
  var o=t.closest('[data-cart-open]');if(o&&N.cartType!=='page'&&!document.body.classList.contains('t-cart')){if(openDrawer())e.preventDefault();return}
  if(t.closest('[data-cart-close]')){e.preventDefault();closeDrawer();return}
  var q=t.closest('[data-line-qty]');if(q){e.preventDefault();changeLine(+q.getAttribute('data-line-qty'),Math.max(0,+q.getAttribute('data-qty-value')));return}
  var w=t.closest('[data-wish]');if(w){e.preventDefault();toggleWish(w.getAttribute('data-wish'));return}
  var st=t.closest('[data-step]');if(st){var box=st.closest('[data-qty]'),inp=box&&box.querySelector('input');if(inp){inp.value=Math.max(+inp.min||1,(+inp.value||1)+(+st.getAttribute('data-step')));inp.dispatchEvent(new Event('change',{bubbles:true}))}return}
  var qa=t.closest('[data-quick-add]');if(qa){e.preventDefault();addToCart([{id:+qa.getAttribute('data-quick-add'),quantity:1}],qa);return}
  var th=t.closest('[data-thumb]');if(th){showMedia(th.closest('[data-product]'),th.getAttribute('data-thumb'));return}
  $$('details[data-close-outside][open]').forEach(function(d){if(!d.contains(t))d.removeAttribute('open')});
});
document.addEventListener('keydown',function(e){
  if(e.key!=='Escape')return;
  if(document.body.classList.contains('drawer-open'))closeDrawer();
  $$('details[data-close-outside][open]').forEach(function(d){d.removeAttribute('open')});
});
document.addEventListener('submit',function(e){
  var f=e.target;
  if(f.matches('[data-product-form]')){
    var sub=e.submitter;if(sub&&sub.name==='return_to')return;
    e.preventDefault();
    var fd=new FormData(f),item={id:+fd.get('id'),quantity:+(fd.get('quantity')||1)},props={};
    fd.forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m&&v!=='')props[m[1]]=v});
    if(Object.keys(props).length)item.properties=props;
    var sp=fd.get('selling_plan');if(sp)item.selling_plan=+sp;
    addToCart([item],f.querySelector('[data-add]'));return;
  }
  if(f.matches('[data-filters]')){$$('input',f).forEach(function(i){if(i.type==='number'&&i.value==='')i.disabled=true})}
  if(f.matches('[data-discount-form]')){e.preventDefault();var c=(f.querySelector('input').value||'').trim();if(c)location.href=(N.routes.root||'/').replace(/\/$/,'')+'/discount/'+encodeURIComponent(c)+'?redirect='+encodeURIComponent(N.routes.cart_url)}
});
document.addEventListener('change',function(e){
  var f=e.target.closest('[data-filters]');
  if(f&&e.target.type!=='number'){if(f.requestSubmit)f.requestSubmit();else f.submit()}
  var ci=e.target.closest('[data-line-input]');if(ci)changeLine(+ci.getAttribute('data-line-input'),Math.max(0,+ci.value||0));
});
document.addEventListener('shopify:section:load',function(e){init(e.target);paintWish();loadWishlist();syncCounts()});
init(document);paintWish();loadWishlist();
})();
